/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Base_CurrencyInputs */

const en_reference_field_base_currency = /** @type {(inputs: Reference_Field_Base_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base currency`)
};

/**
* | output |
* | --- |
* | "Base currency" |
*
* @param {Reference_Field_Base_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_base_currency = /** @type {((inputs?: Reference_Field_Base_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Base_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_base_currency(inputs)
});